import { useCallback, useMemo } from 'react';
import type { FlowPositionItem, ProcessWithSteps } from '@bliks-io/contracts';
import { createProcessFlowAdapter, PROCESS_FLOW_REGISTRY } from '@bliks-io/ui';
import { toastApiError } from '@/api/mutations/toast-api-error';

export function useAutoLayoutAction(
  processForFlow: ProcessWithSteps | null,
  onSavePositions: (args: { positions: FlowPositionItem[] }) => Promise<unknown>
) {
  const adapter = useMemo(() => createProcessFlowAdapter(PROCESS_FLOW_REGISTRY), []);
  return useCallback(async () => {
    if (!processForFlow) return;
    try {
      const assembly = adapter.build({ process: processForFlow });
      const result = await adapter.layout.run(assembly);
      const positions = result.nodes
        .filter((n) => n.type === 'flowActivity' || n.type === 'flowGateway')
        .map((n) => ({ stepId: n.id, x: n.position.x, y: n.position.y }));
      await onSavePositions({ positions });
    } catch (error) {
      toastApiError(error, 'errors.unknown');
    }
  }, [adapter, processForFlow, onSavePositions]);
}
